<template>
  <v-container class="ml-4">
    <v-container class="center" xs12>
      <img :width="s" :height="s" src="../../../assets/me.png" class="profile-pic"/>
    </v-container>
    <v-container align-center class="center" xs12>
      <div  v-for="(soc,i) in social" :key="i">
        <v-btn icon flat :href="soc.href" target="_blank">
          <div class="center" :style="{fontSize:'0.7em', color: '#616161'}">
            <!--<i :class="'fas '+ soc.icon + ' fa-3x'"></i>-->
            <v-icon>{{soc.icon}} fa-3x</v-icon>
          </div>
        </v-btn>
      </div>
    </v-container>
  </v-container>
</template>

<script>
  import json from '../../../data/data.json'
  export default {
    data() {
      return {
        s: this.$vuetify.breakpoint.smAndDown ? 250 : 300,
        social: json.social,
      }
    }
  }
</script>

<style scoped>
  .profile-pic {
    border-radius: 50%;
    border: 0.5em solid white;
  }
</style>



// WEBPACK FOOTER //
// src/components/desktop/home/Left.vue